<template>
  <div>
    <v-card
      class="mx-auto overflow-hidden"
      flat
      tile
    >
      <v-toolbar
        color="#042333"
        dark
      >
        <v-app-bar-nav-icon
          @click="SET_DRAWER(true)"
          color="white"
        />

        <v-toolbar-title
          class="titulo-empresa"
          @click="LINK_PARAMETRIZACAO()"
        >
          <img
            :src="empresa.logo_header"
            class="img-empresa-header"
            width="230"
          />
        </v-toolbar-title>
      </v-toolbar>
    </v-card>

    <NavigationDrawer />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import NavigationDrawer from "./NavigationDrawer.vue";

export default {
  components: { NavigationDrawer },
  data: () => ({

  }),
  computed: {
    ...mapState("app", ["empresa"]),
  },
  methods: {
    ...mapMutations({
      SET_DRAWER: "MenuParametrizacaoIncludes/SET_DRAWER"
    }),
    LINK_PARAMETRIZACAO() {
      this.$route.name == "Parametrizacao" ? this.$router.push("/dashboard") : this.$router.push("/parametrizacao");
    },
  }
}
</script>

<style scoped>
.titulo-empresa {
  color: #fff;
  cursor: pointer;
}

.img-empresa-header {
  padding: 3% 5% 5% 5%;
  margin-top: 5%;
  margin-left: -15%;
}
</style>

